import {
    calcTime,
    clearROICache,
    daysBetween,
    fetchMatchCodeFromString,
    formatString,
    getMatch,
    getMatchInfoTitle,
    startHTTPRequest
} from "../../../assets/js/common";
import {
    CFG_TOUR_SERIES_NAME_IPL,
    CFG_WIDGET_API_BASE,
    SPORT_LIST
} from "../../../assets/js/config";
import { SUCCESS_FETCH_MATCH_DATA, UPDATE_MATCH_STATE } from "../../types";

const restructureMatchArray = (matches) => {
    let restructuredObj = {};
    matches.forEach((match) => {
        if (Array.isArray(restructuredObj[match.category_id])) {
            restructuredObj[match.category_id].push(match);
        } else {
            restructuredObj[match.category_id] = [match];
        }
    });
    return restructuredObj;
};
const getCurrentMatchSlug = (state, rootData) => {
    if (
        rootData.route &&
        rootData.route.params &&
        rootData.route.params.slug &&
        getMatch(state.match_data, "slug", rootData.route.params.slug, true) !== -1
    ) {
        let match = getMatch(state.match_data, "slug", rootData.route.params.slug);
        return match.slug;
    } else {
        let firstMatchNode = state.match_data[state.current_category].find(
            (e) => true
        );
        return firstMatchNode.slug;
    }
};
const getCurrentMatchCategory = (state, rootData) => {
    if (
        rootData.route &&
        rootData.route.params &&
        rootData.route.params.slug &&
        getMatch(state.match_data, "slug", rootData.route.params.slug, true) !== -1
    ) {
        let match = getMatch(state.match_data, "slug", rootData.route.params.slug);
        return { category_id: match.category_id, sport_id: match.sport_id };
    } else {
        return getFirstCategoryBySportOrder(state.in_match_categories);
    }
};

const getFirstCategoryBySportOrder = (categories) => {
    let first_cat = { category_id: null, sport_id: null };
    for (let s = 0; s < SPORT_LIST.length; s++) {
        let sport = SPORT_LIST[s];
        let first_cat_by_sport = categories.find(c => c.sport_id === sport.id);
        if (first_cat_by_sport) {
            first_cat = { category_id: first_cat_by_sport.category_id, sport_id: first_cat_by_sport.sport_id };
            break;
        }
    }
    return first_cat;
}
const checkIfPreviouslyLoaded = (state, match) => {
    if (
        (Array.isArray(state.match_data) && !state.match_data.length) ||
        (Object.entries(state.match_data).length === 0 &&
            state.match_data.constructor === Object)
    )
        return false;
    let found = getMatch(state.match_data, "slug", match.slug);
    return found && found.isLoaded;
};

const replaceSpecificSeriesNames = (match) => {
    let { series_name, tour_name } = match;
    if (
        new RegExp(`${CFG_TOUR_SERIES_NAME_IPL.from}`, "ig").test(series_name)
    ) {
        series_name = series_name.replace(
            new RegExp(`${CFG_TOUR_SERIES_NAME_IPL.from}`, "ig"),
            `${CFG_TOUR_SERIES_NAME_IPL.to}`
        );
    }
    if (new RegExp(`${CFG_TOUR_SERIES_NAME_IPL.from}`, "ig").test(tour_name)) {
        tour_name = tour_name.replace(
            new RegExp(`${CFG_TOUR_SERIES_NAME_IPL.from}`, "ig"),
            `${CFG_TOUR_SERIES_NAME_IPL.to}`
        );
    }
    match.series_name = series_name;
    match.tour_name = tour_name;
};

const setTitleNode = (match, headlinesArr) => {
    let menu_card_title = getMatchInfoTitle(match, headlinesArr.menu_card, true);
    let lineup_title = getMatchInfoTitle(match, headlinesArr.lineup, true);
    let match_info_title = getMatchInfoTitle(match, headlinesArr.match_info, true);

    match.titles = {
        menu_card_title,
        lineup_title,
        match_info_title,
    };
};

const updateMatchesSequence = (matches, currentMatchCode) => {
    let currentMatch = (matches || []).find(m => m.code === currentMatchCode);
    if(currentMatch) {
        let currentMatchCatMatches = matches.filter(m => m.category_id === currentMatch.category_id);
        let indexOfCurrMatch = currentMatchCatMatches.findIndex(m => m.code === currentMatch.code)
        let otherCatMatches = matches.filter(m => m.category_id !== currentMatch.category_id);
        let matchesBeforeCurrent = currentMatchCatMatches.slice(0, indexOfCurrMatch);
        let matchesFromCurrent = currentMatchCatMatches.slice(indexOfCurrMatch, (currentMatchCatMatches.length));
        return [...matchesFromCurrent, ...matchesBeforeCurrent, ...otherCatMatches];
    } else {
        return matches;
    }
}

const match_detail_store = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.match_detail_store) ? window.__ROI_STATE_DATA__.match_detail_store :{
        isLoading: !!(typeof window === "undefined"),
        match_store_filled: false,
        match_api_version: null,
        in_match_categories: [],
        current_category: null,
        no_matches_active: false,
        match_data: [],
        slug: null,
        is_initial_request:
            typeof window === "undefined" ? undefined : Date.now(),
        is_custom_client: {
            status: false,
        },
        isLiveScoringActive: false,
        archived_match_code: null,
        isMatchesLoaded: false,
        isTourActive: false,
        sportList: [1, 2],
        current_sport: null,
        sportDetails: {
            "1": {
                hasMatches: false,
                name: "Cricket",
                className: "sports-cricket"
            },
            "2": {
                hasMatches: false,
                name: "Football",
                className: "sports-football"
            }
        },
        activeModule: null,
    }),
    actions: {
        fetchMatchData: ({ commit, state, rootState }) => {
            console.log("fetchMatchData action received ---->");
            let { route, translations } = rootState;
            const code = route && route.params && fetchMatchCodeFromString(route.params.slug);

            if (typeof window === "undefined" && typeof code !== "undefined") {
                //executed in context of ssr
                state.archived_match_code = code;
            } else if (
                typeof code !== "undefined" &&
                state.archived_match_code === null
            ) {
                //context of frontend (used in local dev)
                state.archived_match_code = code;
            }

            let actionData = {
                method: "GET",
                url: `${CFG_WIDGET_API_BASE}api/App/GetMatches`,
                headers: {
                    "content-type": "application/json",
                    "accept": "*/*",
                },
                params: {},
                can_append: false,
                addAuthorization: false
            };
            if (state.archived_match_code) {
                actionData.params["matchcode"] = state.archived_match_code;
            }
            /* if (module === "customWidget") { // check for NDTV
                actionData.params["buster"] = Date.now();
            } */
            return startHTTPRequest(actionData)
                .then((res) => {
                    let { matches, version, categories } = res;
                    matches = matches.filter(m => {
                        let is_available_on_fe = m.show_in_fe;
                        let urlMatch = m.code == code;
                        if(urlMatch && !urlMatch.show_in_fe) {
                            m.noLink = true;
                        }
                        return (urlMatch || is_available_on_fe)
                    })
                    categories = categories.filter(c => {
                        let urlMatch = matches.find(m => (m.category_id == c.category_id && m.code == code))
                        if(urlMatch && !urlMatch.show_in_fe) {
                            c.noLink = true;
                        }
                        let hasMatchAvailable = matches.find(m => (m.category_id == c.category_id && m.show_in_fe))
                        return (urlMatch || hasMatchAvailable);
                    })
                    state.match_api_version = version;
                    commit(SUCCESS_FETCH_MATCH_DATA, {
                        matches,
                        version,
                        categories,
                        rootData: { route, translations }
                    });
                    if (typeof window !== "undefined") {
                        state.isMatchesLoaded = true;
                        clearROICache(matches);
                    }
                    /* let isInitial =
                        typeof window !== "undefined" &&
                        typeof state.is_initial_request === "undefined";
                    
                    if (module === CFG_MODULES.GAME_PLAN.name) {
                        isInitial && (state.is_initial_request = Date.now());

                    } else if (module === CFG_MODULES.LINEUP.name) {
                        isInitial && (state.is_initial_request = Date.now());

                    } else if (module === CFG_MODULES.MATCH_INFO.name) {
                        isInitial && (state.is_initial_request = Date.now());

                    } else {
                        state.is_initial_request = Date.now();
                    } */
                })
                .catch((e) => {
                    console.log(e);
                    console.log(e.toString());
                    commit(SUCCESS_FETCH_MATCH_DATA, {
                        matches: [],
                        version: null,
                        categories: [],
                        rootData: { route, translations }
                    });
                });
        },
        slideChange: ({ state }, payload) => {
            state.slug = payload.slug;
        },
        updateMatchState: ({ commit }, payload) => {
            return commit(UPDATE_MATCH_STATE, payload);
        },
        updateRootMatchData: ({ commit, rootState }, payload) => {
            let { route, translations } = rootState;
            let { matches, version, categories } = payload;
            return commit(SUCCESS_FETCH_MATCH_DATA, {
                matches,
                version,
                categories,
                rootData: { route, translations }
            });
        },
        setActiveModule: ({ state }, moduleName) => {
            state.activeModule = moduleName;
        },
        setLiveScoringFlag: ({ state }, newVal) => {
            state.isLiveScoringActive = newVal;
        }
    },
    mutations: {
        [SUCCESS_FETCH_MATCH_DATA]: (state, payload) => {
            state.match_store_filled = true;
            let { matches, version, categories, rootData } = payload;
            state.isLoading = false;
            state.match_api_version = version;
            matches.map((match) => {
                let current_date = new Date();
                let start_time = new Date(
                    calcTime(new Date(match.start_date))
                );
                if (state.sportDetails[match.sport_id] && !state.sportDetails[match.sport_id].hasMatches) {
                    state.sportDetails[match.sport_id].hasMatches = true;
                }
                match.upcoming_in = daysBetween(current_date, start_time, match.start_date);
                match.isLoaded = checkIfPreviouslyLoaded(state, match);
                if(match.status === 1 && match.upcoming_in && match.upcoming_in.is_expired) {
                    match.status = -2;
                }
                replaceSpecificSeriesNames(match)
                setTitleNode(match, {
                    menu_card: rootData.translations.contests_headline,
                    lineup: rootData.translations.lineup_headline,
                    match_info: rootData.translations.match_tips_headline
                });
            });
            if(rootData && rootData.route && rootData.route.params && rootData.route.params.slug) {
                let currentCode = fetchMatchCodeFromString(rootData.route.params.slug);
                matches = updateMatchesSequence(matches, currentCode);
            }
            if (matches.length === 0) {
                state.no_matches_active = true;
                return;
            }

            categories = categories.map((cat) => {
                if (cat.sport_id === 0) {
                    /* This is to fix sport_id 0 issue */
                    let match = matches.find(m => m.category_id === cat.category_id);
                    if (match) {
                        cat.sport_id = match.sport_id;
                    }
                }
                return {
                    ...cat,
                    ...{
                        slug: formatString(cat.category_name),
                    },
                };
            });

            state.in_match_categories = categories;
            state.match_data = restructureMatchArray(matches);
            let currentMatchCategory = getCurrentMatchCategory(state, { route: rootData.route });
            state.current_category = currentMatchCategory.category_id;
            state.current_sport = currentMatchCategory.sport_id;
            state.slug = getCurrentMatchSlug(state, { route: rootData.route });
        },
        [UPDATE_MATCH_STATE]: (state, payload) => {
            for (let cat in state.match_data) {
                for (let i = 0; i < state.match_data[cat].length; i++) {
                    if (state.match_data[cat][i].code === payload.code) {
                        state.match_data[cat][i].isLoaded = payload.match_loaded;
                    }
                }
            }
        }
    }
}

export default match_detail_store;